import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Helmet } from 'react-helmet';
import { MandatoryAdditionalStyle } from '../../components.utils';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { BlockWidths } from '../../components/pageLayouts/BlockTypes.utils';
import { createBlockStyle } from '../blockMutualStyle';

interface ApesterDataProps {
    html: string;
    dataId?: string;
    defaultBlocksWidths: BlockWidths;
}

type IframeComponentProps = ApesterDataProps & MandatoryAdditionalStyle;
export type IframeProps = ApesterDataProps & MandatoryAdditionalStyle;

const getStyle = (defaultBlocksWidths: BlockWidths) => {
  return StyleSheet.create({
    style: {
      ...createBlockStyle(defaultBlocksWidths),
    },
  }).style;
};

export const Apester: React.FunctionComponent<IframeComponentProps> = props => {
  const { html, additionalStyle, dataId, defaultBlocksWidths } = props;
  const style = getStyle(defaultBlocksWidths);
  return (
    <ErrorBoundary>
      <Helmet>
        <script async defer src="https://static.apester.com/js/sdk/latest/apester-sdk.js" />
      </Helmet>
      <div className={css(additionalStyle.style, style)}>
        {/* eslint-disable-next-line react/no-danger */}
        <figure data-mm-id={dataId} dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </ErrorBoundary>
  );
};
